import * as React from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
// import ArticleList from '../../components/ArticleList'
import { WS_HOST } from '../../config'
import { cutString } from '../../util'
// import history from '../../history'
import PageComponent from '../../components/Pagination'
import Subscribe from '../../components/Subscribe'

import {
    submitFavorites,
    submitSubscribes,
    fetchReports,
    fetchedReports,
    fetchNewReport,
    fetchSubscribes,
    fetchedSubscribes
} from './actions'
import { updateFavoriteArticle } from '../../actions'
import { getFavoriteListSuccess } from '../../components/Header/actions'

import './index.css'
import '../../css/public.css'
import ArticleBox from '../../components/ArticleBox'

class Article extends React.Component<any, any> {
    private allowNotification: boolean 
    private ws: any
    private mySubscribes: any = []
    constructor(props: any) {
        super(props)
        this.state = {
            current: 1, //  当前页码
            pageSize: 5, //  每页显示的条数5条
        }
    }

    componentDidMount() {
        Notification.requestPermission().then((result) => {
            this.allowNotification = (result === 'granted') ? true : false
        })

        this.ws = new WebSocket(WS_HOST + '/' + this.props.token + '/')

        this.ws.addEventListener('message', (e: any) => {
            const report = JSON.parse(e.data)

            if (report.code === 1024) {
                // history.push('/login')
            } else {
                if (this.allowNotification) {
                    this.notifiy(report)
                }

                this.props.fetchNewReport(report)
            }
        })
        this.props.fetchSubscribes()
    }

    componentWillReceiveProps(nextProps: any) {
        if (this.props.subscribes.entities.length === 0 && nextProps.subscribes.entities.length > 0) {
            this.updateMySubscribes(nextProps.subscribes.entities, 1)
        }

        if (this.props.newReport.report_id !== nextProps.newReport.report_id) {
            let reports = this.props.reports.entities
            reports.result = [nextProps.newReport, ...this.props.reports.entities.result.slice(0, -1)]

            this.props.fetchedReports(reports)
        }
    }

    componentWillUnmount() {
        this.ws.removeEventListener('message', (e: any) => {
            this.props.fetchNewReport(e.data)
        })
        this.ws.close()

        this.props.fetchNewReport({})
        this.props.fetchedSubscribes([])
        this.props.fetchedReports({})
    }

    notifiy = (data: any) => {
        const title = data.article_title
        const options = {
            body: cutString(data.article_content, 80),
        }
        new Notification(title, options)
    }

    updateMySubscribes = (subscribes: any, page: number) => {
        // gather user subscribes
        this.mySubscribes = []
        for (let i = 0; i < subscribes.length; i++) {
            for (let j = 0; j < subscribes[i].value.length; j++) {
                if (subscribes[i].value[j].checked) {
                    this.mySubscribes.push(subscribes[i].value[j].id.toString())
                }
            }
        }
        // fetch new reports according to new user subscribes 
        if (this.mySubscribes.length > 0) {
            this.props.fetchReports( this.mySubscribes.join(','), page)
        } else {
            this.props.fetchedReports('', 1)
        }

        if (this.ws.readyState === 1) {
            this.ws.send('update_subscribe')
        }
    }

    handleCheckboxChange = (type: number, checked: boolean, index: number) => {
        let newEntities = this.props.subscribes.entities
        newEntities[type].value[index].checked = !checked

        // immediately toggle checkbox
        this.props.fetchedSubscribes(newEntities)

        this.updateMySubscribes(newEntities, 1)

        this.props.submitSubscribes({
            list_subscribe: this.mySubscribes.join(',')
        })
    }

    goTo(url: any) {
        window.open(url, '_blank')
    }

    updateFavoriteState(action: any, index: number) {
        const data = {
            action: action,
            favorites_list: this.props.reports.entities.result[index].report_id
        }
        this.props.updateFavoriteArticle(data)

        let newReports = this.props.reports.entities
        newReports.result[index].enable_favorites = !this.props.reports.entities.result[index].enable_favorites
        this.props.fetchedReports(newReports)

        if (this.props.favoriteList.entities) {
            let favorites = this.props.favoriteList.entities
            if (action === 'add') {
                favorites.push(
                    {
                        id: this.props.reports.entities.result[index].report_id,
                        title: this.props.reports.entities.result[index].article_title
                    }
                )
            } else {
                for (let i = 0; i < favorites.length; i++) {
                    if (favorites[i].id === this.props.reports.entities.result[index].report_id) {
                        favorites.splice(i, 1)
                    }
                }
            }
            this.props.fetchFavoriteList(favorites)
        }
    }
    showCheckbox(index: any) {
        let newEntities = this.props.subscribes.entities
        newEntities[index].checked = !this.props.subscribes.entities[index].checked
        this.props.fetchedSubscribes(newEntities)
        this.updateMySubscribes(newEntities, 1)
    }
    handlePageChange() {
        let newEntities = this.props.subscribes.entities
        this.updateMySubscribes(newEntities, this.state.currentPage + 1)

    }
    //  点击翻页
    pageClick(pageNum: any) {
        if (pageNum !== this.state.current) {
            this.setState(
                {
                    current: pageNum
                }
            )
        }
        // 更新数据
        let newEntities = this.props.subscribes.entities
        // immediately toggle checkbox
        this.props.fetchedSubscribes(newEntities)
        this.updateMySubscribes(newEntities, pageNum)
    }
    //  上一步
    goPrevClick() {
        let cur = this.state.current;
        if (cur > 1) {
            this.pageClick( cur - 1);
        }
    }
    //  下一步
    goNext() {
        let cur = this.state.current;
        //  alert(cur+"==="+this.state.totalPage)
        if (cur < Math.ceil(this.props.reports.entities.count / 10)) {
            this.pageClick(cur + 1);
        }
    }
    //  跳转到指定页
    goSwitchChange(page: any) {
        //  alert(value+"==="+this.state.totalPage)
        let totalPage = Math.ceil(this.props.reports.entities.count / 10)
        if (/^[1-9]\d*$/.test(page) && Number(page) <= Number(totalPage)) {
            this.pageClick(page);
        }
    }
    goToAuthor(authorId: any) {
        return 1
    }
    render() {
        const subscribes = this.props.subscribes.entities
        const reports = this.props.reports.entities.result
        return (
            <div className="article grow">
                <Helmet title="研报列表 - 投研通"/>
                <div className="article-container">
                    {
                        subscribes &&
                        <Subscribe subscribes={subscribes} handleCheckboxChange={(index: any, checked: any, ind: any) => this.handleCheckboxChange(index, checked, ind)} showCheckbox={(index: any) => this.showCheckbox(index)}/>
                    }
                    <div className="articleList">
                    {reports &&
                        <ArticleBox reports={this.props.reports.entities.result} jumpToPdf={(url: any) => this.goTo(url)} jumpToAuthor={(secId: any) => this.goToAuthor(secId)} handleFavoriteState={(state: any, index: number) => this.updateFavoriteState(state, index)}/>
                        }
                    </div>
                </div>
                <div className="pagination-box">
                    {
                        reports &&
                        <PageComponent total={Math.ceil(this.props.reports.entities.count / 10)}  current={this.state.current} totalPage={Math.ceil(this.props.reports.entities.count / 10)} pageClick={(page: any) => this.pageClick(page)} goPrev={() => this.goPrevClick()} goNext={() => this.goNext()} switchChange={(page: any) => this.goSwitchChange(page)}/>
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        token: state.fetchedToken,
        subscribes: state.getSubscribes,
        reports: state.reports,
        favoriteList: state.favoriteList,
        newReport: state.newReport,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        fetchSubscribes: (data: object) => dispatch(fetchSubscribes(data)),
        fetchedSubscribes: (data: any) => dispatch(fetchedSubscribes(data)),
        fetchReports: (subscribes: any, page: number) => dispatch(fetchReports(subscribes, page)),
        fetchedReports: (data: object) => dispatch(fetchedReports(data)),
        fetchFavoriteList: (data: object) => dispatch(getFavoriteListSuccess(data)),
        fetchNewReport: (data: object) => dispatch(fetchNewReport(data)),
        submitFavorites: (data: object) => dispatch(submitFavorites(data)),
        submitSubscribes: (data: object) => dispatch(submitSubscribes(data)),
        updateFavoriteArticle: (data: object) => dispatch(updateFavoriteArticle(data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Article)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/scenes/Article/index.tsx